import {Serializable, SerializationHelper} from "@/helpers/SerializationHelper";

export class Drive implements Serializable  {
    driveId: string;
    driveLabel: string;
    wms: string;
    hybrid: boolean;
    relay: boolean;

    fromJSON(rawObject: any) {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, []);
    }
}
